<template>
  <AppModal
    v-model="showModal"
    :title="title"
    :no-escape="true"
    :no-backdrop="true"
    :no-close-button="true"
  >
    <template #body>
      <slot>
        <div class="mt-2">
          <p class="text-base">{{ message }}</p>
        </div>
      </slot>
    </template>

    <template #footer>
      <div class="bg-white py-3 flex px-6 justify-end gap-2">
        <BaseButton
          text="Cancel"
          :disabled="isDeleting"
          :class="{ 'cursor-not-allowed opacity-50': isDeleting }"
          @click="showModal = false"
        />

        <BaseButton
          variant="danger"
          :disabled="isDeleting"
          :class="{ 'cursor-not-allowed opacity-50': isDeleting }"
          @click="emitDelete()"
        >
          <div class="flex justify-between items-center gap-2">
            <span>Delete</span>
            <span
              v-if="isDeleting"
              class="i-heroicons-arrow-path animate-spin"
            />
          </div>
        </BaseButton>
      </div>
    </template>
  </AppModal>
</template>

<script lang="ts" setup>
import BaseButton from '@/components/base/BaseButton.vue'
import AppModal from '@/components/app/AppModal.vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: false,
    default: 'Are you sure you want to delete this item?'
  },
  value: {
    type: Boolean,
    required: false,
    default: false
  },
  size: {
    type: String,
    required: false,
    default: ''
  },
  isDeleting: {
    type: Boolean,
    default: false
  }
})

const showModal = defineModel({
  type: Boolean,
  default: false
})

const emit = defineEmits(['delete'])

const emitDelete = () => {
  emit('delete')
  showModal.value = false
}

</script>
